module.exports = __webpack_public_path__ + "static/default-discount-ff6862b600e54d1d110b0a74d4317399.png";